var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCodeAndFlash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 18.125l6.4-6.4-6.4-6.4M10.533 20.259h8.534",
    stroke: "#525376",
    strokeWidth: 2.879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.855 0l-8.556 13.2H31l-.855 8.8 8.555-13.2H31l.856-8.8z",
    fill: "#525376"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzkiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAzOSAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIgMTguMTI1NEw4LjQwMDI3IDExLjcyNTFMMiA1LjMyNDgzIiBzdHJva2U9IiM1MjUzNzYiIHN0cm9rZS13aWR0aD0iMi44Nzg5MSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xMC41MzMyIDIwLjI1ODlIMTkuMDY2OSIgc3Ryb2tlPSIjNTI1Mzc2IiBzdHJva2Utd2lkdGg9IjIuODc4OTEiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMzEuODU0OCAwTDIzLjI5OTMgMTMuMkgzMC45OTkzTDMwLjE0MzcgMjJMMzguNjk5MyA4LjhIMzAuOTk5M0wzMS44NTQ4IDBaIiBmaWxsPSIjNTI1Mzc2Ii8+Cjwvc3ZnPgo=";
export { SvgCodeAndFlash as ReactComponent };